import './protocol-adherence/protocol-adherence-upload';
import './protocol-adherence/protocol-adherence-cart-validation';
import './protocol-adherence/protocol-adherence-cart-remove';
import './protocol-adherence/protocol-adherence-delete';
import './protocol-adherence/protocol-adherence-duplicate';
import './protocol-adherence/print-preview-adherence';